<div *ngIf="currentPage == null || currentPage == undefined" class="loading"></div>
<div *ngIf="currentPage != null && currentPage != undefined && !showFinishPage">
    <smt-staffing-plan-page 
        [currentPage]="currentPage" 
        (doneButtonClicked)="done()"
        (nextButtonClicked)="next($event)" 
        (previousButtonClicked)="previous()"
        (skipButtonClicked)="skip()">
    </smt-staffing-plan-page> 
</div>

<div *ngIf="currentPage != null && currentPage != undefined && showFinishPage ">
<smt-workflow-finish
[costCenter]="currentPage?.shiftRecord?.costCenter" 
[shiftBlock]="currentPage?.shiftRecord?.shiftBlock" 
[workflowTime]="currentPage?.shiftRecord?.workflowTimeFacility"
>
</smt-workflow-finish>
</div>
